import { Box, makeStyles, Typography } from "@material-ui/core";
import { useState } from "react";
import { Trash2 } from "react-feather";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../../components/Confirm";

const useStyles = makeStyles((theme) => ({
  textLight: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "18px",
    fontWeight: 300,
    color: "#114668",
    alignSelf: "start",
    marginRight: "10px",
  },
  mainContainer: {
    width: "90%",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  divider: {
    height: "1px",
    backgroundColor: "#bcbcbc",
  },
  horizontalBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  verticalBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const CalendarEventItem = ({ event, onDeleteEvent }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    DAY: startDay,
    MONTH: startMonth,
    YEAR: startYear,
  } = event.EVENT_START_DATE;
  const { HOUR: startHour, MINUTE: startMinute } = event.EVENT_START_TIME;
  const { DAY: endDay, MONTH: endMonth, YEAR: endYear } = event.EVENT_END_DATE;
  const { HOUR: endHour, MINUTE: endMinute } = event.EVENT_END_TIME;

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <Box className={classes.mainContainer}>
        {isDialogOpen && (
          <ConfirmDialog
            message={t("calendar_event.confirm_dialog_message")}
            onConfirm={onDeleteEvent}
            onClose={() => setIsDialogOpen((prev) => !prev)}
          />
        )}
        <Box className={classes.horizontalBox}>
          <Box className={classes.verticalBox}>
            <Typography className={classes.textLight}>
              {event.EVENT_NAME}
            </Typography>
            <Typography className={classes.textLight}>
              {`${t("calendar_event_item.from")}: ${startDay}/${startMonth}/${startYear} - ${startHour}:${String(startMinute).padStart(2, "0")}`}
            </Typography>
            <Typography className={classes.textLight}>
              {`${t("calendar_event_item.to")}: ${endDay}/${endMonth}/${endYear} - ${endHour}:${String(endMinute).padStart(2, "0")}`}
            </Typography>
          </Box>
          <Box
            className={classes.verticalBox}
            onClick={() => setIsDialogOpen((prev) => !prev)}
          >
            <Trash2 color="red" />
          </Box>
        </Box>
        <div className={classes.divider} />
      </Box>
    </>
  );
};

export default CalendarEventItem;
